<template>
    <div>
        <card>
            <div class="row" style="margin-left:5px">
                <button @click="modals.mini = true" class="btn float-left" type="button" style="margin-top:10px;background:#00467f">Cerca Azienda</button>
            </div>
            <!-- <h3 style="margin-top:10px;margin-left:5px">Nota di Credito</h3> -->
            <hr>
            <form>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="ufficio">Ufficio<span style="color:#ff0000">*</span></label>
                        <!-- <input type="text" class="form-control" id="ufficio" v-model="ufficio" readonly> -->
                        <select id="ufficio" v-model="ufficio" class="form-control" readonly>
                            <option v-for="valori in sedi" v-bind:key="valori.ID" :value="valori.ID" v-on:change="getRichiedenti(valori.ID)">{{valori.DENOMINAZIONE}} - {{valori.UFFICIO}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="cognome_nome_richiedente">Cognome e nome richiedente nota di credito<span style="color:#ff0000">*</span></label>
                        <input type="text" class="form-control" id="cognome_nome_richiedente" v-model="cognome_nome_richiedente" readonly>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="codice_fiscale">Codice Fiscale<span style="color:#ff0000">*</span></label>
                        <input type="text" class="form-control" id="codice_fiscale" v-model="codice_fiscale" placeholder="codice fiscale" readonly>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="inputAddress">Denominazione<span style="color:#ff0000">*</span></label>
                        <input type="text" class="form-control" v-model="denominazione" id="denominazione" placeholder="denominazione" readonly>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="numero_fattura">Numero Fattura<span style="color:#ff0000">*</span></label>
                        <input type="numer" class="form-control" v-model="numero_fattura" id="numero_fattura" placeholder="123" readonly>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="data_fattura">Data Fattura<span style="color:#ff0000">*</span></label>
                        <input type="date" class="form-control" v-model="data_fattura" id="data_fattura" readonly>
                    </div>
                </div>
                    <!--  -->
                <!-- <div class="form-row">
                    <div class="form-group col-md-12">
                        <textarea lass="form-control" v-model="causale_nota" id="causale_nota"></textarea>
                    </div>
                </div> -->
                <div class="form-row justify-content-center">
                    <!-- <div class="form-group col-md-4">
                        <div style="margin-top:30px;margin-bottom:10px">
                            <label class="label-switch">Storno parziale</label>
                            <label class="switch" style="margin-top:10px">
                                <input type="checkbox" class="form-control" v-model="storno_intero" style="margin-top:20px" readonly="readonly"><span class="slider round"></span>
                            </label>
                            <label  class="label-switch">Stornare intera fattura</label>
                        </div>
                    </div> -->
                    <div class="form-group col-md-4"  v-if="importo != '0.00'">
                        <label for="importo">Importo</label>
                        <div class="input-icon">
                            <!-- <input type="text" class="form-control" placeholder="0.00"> -->
                            <input type="number" class="form-control" v-model="importo" id="importo" placeholder="0.00" readonly>
                            <i>€</i>
                        </div>
                    </div>
                    <div class="form-group col-md-4" v-else>
                        <label for="storna_intera">Stornare intera fattura</label>
                        <input type="checkbox" class="form-control" checked id="storna_intera"  readonly="readonly">
                    </div>
                    <div class="form-group col-md-4">
                        <label for="metodo_importo">Modalità pagamento della fattura<span style="color:#ff0000">*</span></label>
                        <input type="text" class="form-control" v-model="metodo" id="metodo_importo" readonly>
                    </div>
                   
                </div>
               
                <div class="form-row  justify-content-center">
                    <div class="form-group col-4" v-if="user_livello == 1 || userl_livello == 2">
                        <label class="form-check-label" for="urgente">Emissione Urgente<input class="form-control" type="checkbox" id="urgente" v-model="urgente" readonly="readonly"></label>
                    </div>
                    <div class="form-group col-md-4" v-if="urgente">
                        <label for="data_ultima_emissione">Termine ultimo emissione nota<span style="color:#ff0000">*</span></label>
                        <input type="date" class="form-control" v-model="data_ultima_emissione" id="data_ultima_emissione" readonly>  
                    </div>
                    <div class="form-group col-md-4" v-else></div>
                </div> 
                <div class="form-row justify-content-center"  v-if="user_livello == 1 || user_livello == 2">
                    <div style="margin-top:30px;margin-bottom:10px">
                        <label class="label-switch" style="font-size:18px"><b>NON</b> autorizzo emissione</label>
                        <label class="switch" style="margin-top:10px">
                            <input type="checkbox" class="form-control" v-model="autorizzazione_emissione" style="margin-top:20px"><span class="slider round"></span>
                        </label>
                        <label  class="label-switch" style="font-size:18px">Autorizzo emissione</label>
                    </div>
                    <div class="form-group col-md-8" v-if="autorizzazione_emissione == false || autorizzazione_emissione == null">
                        <label for="note">Note per nota non autorizzata</label>
                        <!-- <input type="text" class="form-control" id="note" v-model="nota_responsabile"> -->
                        <textarea lass="form-control" v-model="nota_responsabile" id="note" rows="3" style="width:100%;background:#e9ecee;border-radius:7px"></textarea>
                    </div>
                </div>
                <div class="form-row justify-content-center" v-else>
                    <div class="form-group col-md-12" v-if="autorizzazione_emissione == false">
                        <label for="note">Note per nota non autorizzata</label>
                        <!-- <input type="text" class="form-control" id="note" v-model="nota_responsabile" readonly> -->
                        <textarea lass="form-control" v-model="nota_responsabile" id="note" rows="3" style="width:100%;background:#e9ecee;border-radius:7px" readonly></textarea>
                    </div>
                </div>
                <div class="form-row justify-content-center" v-if="autorizzazione_emissione == true">
                     <div class="form-group col-4">
                        <label class="form-check-label" for="emissione">Emessa<input class="form-control" type="checkbox" id="emissione" v-model="emissione"></label>
                    </div>
                     <div class="form-group col-4">
                        <label for="riferimento_nota">Riferimento nota<span style="color:#ff0000">*</span></label>
                        <input v-if="user_livello == 1 || usrl_livello == 2" type="numer" class="form-control" v-model="riferimento_nota" id="riferimento_nota" placeholder="123">
                        <input v-else type="numer" class="form-control" v-model="riferimento_nota" id="riferimento_nota" placeholder="123" readonly>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <label for="causale_nota">Causale nota<span style="color:#ff0000">*</span></label>
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <textarea lass="form-control" v-model="causale_nota" id="causale_nota" rows="3" style="width:100%;background:#e9ecee;border-radius:7px" readonly></textarea>
                            </div>
                        </div>                    
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="erroreCausatoDa">Cognome e nome persona che ha causato l'errore<span style="color:#ff0000">*</span></label>
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <textarea lass="form-control" v-model="erroreCausatoDa" id="erroreCausatoDa" rows="3" style="width:100%;background:#e9ecee;border-radius:7px" readonly></textarea>
                            </div>
                        </div>                    
                    </div>
                    <div class="form-group col-md-6">
                        <label for="motivazione">Motivazione dell'errore<span style="color:#ff0000">*</span></label>
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <textarea lass="form-control" v-model="motivazione" id="motivazione" rows="3" style="width:100%;background:#e9ecee;border-radius:7px" readonly></textarea>
                            </div>
                        </div>                    
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <label for="azioneIntrapresa">Azioni intraprese per non ripetere lo stesso errore<span style="color:#ff0000">*</span></label>
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <textarea lass="form-control" v-model="azioneIntrapresa" id="azioneIntrapresa" rows="3" style="width:100%;background:#e9ecee;border-radius:7px" readonly></textarea>
                            </div>
                        </div>                    
                    </div>
                </div>
                
                <!-- <div class="form-row" v-if="autorizzazione_emissione == false">
                    <div class="form-group col-md-12">
                        <label for="note">Note</label>
                        <input type="text" class="form-control" id="note" v-model="nota_responsabile" readonly>
                    </div>
                </div> -->
                
                <div class="form-row"  v-if="carica_nota.user != null">
                    <div class="form-group col-md-6">
                        <label for="ufficio" style="font-size:14px">Nome Cognome Referente</label>
                        <input type="text" class="form-control" id="codice_fiscale" v-model="nome_cognome" readonly>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="codice_fiscale" style="font-size:14px">Ufficio Referente</label>
                        <input type="text" class="form-control" id="codice_fiscale" v-model="ufficio_referente" readonly>
                    </div>
                </div>
                <!-- <div class="form-row">
                    <div class="form-group">
                        <label for="file">Carica scansione fattura</label><br>
                        <button class="btn" style="margin-left:10px;font-size:12px;background:#00467f">Scegli file<input class="form-control" type="file" multiple name="documento" ref="file" v-on:change="checkFileUpload()"></button>
                    </div>
                </div> -->
                <div class="row justify-content-start" style="margin-top:10px;">
                    <div class="col">
                        <div v-if="carica_nota.A_ACCREDITO_META.length > 0" style="margin-top:15px">
                            <p>File caricati:</p>
                            <div v-for="value in carica_nota.A_ACCREDITO_META" v-bind:key="value.ID">
                                <p><a :href="'https://sviluppoallergeni.confcom.it'+  value.VALUE.url  + '?token='+access_token" target="_blank" style="color:black">{{value.VALUE.name}}</a></p>
                            </div>
                        </div>
                        <div v-else></div>
                    </div>
                    <div class="col"></div>
                    <div class="col"></div>
                </div>
                <button v-if="user_livello == 1 || userl_livello == 2" type="button" class="btn float-right" style="background:#00467f" v-on:click="salvaValori()">Salva</button>
                <!-- <div class="col"> -->
                <router-link to="/note-credito" class="btn float-right" style="margin-right:10px;background:#00467f">Indietro</router-link>
                <!-- </div> -->
                <button v-if="user_livello == 1" type="button" class="btn float-left" style="background:#00467f" v-on:click="cancellaNota()">Cancella Nota</button>
            </form>
        </card>
        
        <modal :show.sync="modals.mini"
                :show-close="false"
                header-classes="justify-content-center"
                type="mini"
                style="position:fixed;overflow: auto;"><!--vertical-align: middle;overflow: auto; transform: translateY(-40%) -->
            <div class="modal-profile d-flex">
                <!--<i class="nc-icon nc-watch-time"></i>-->
                <button class="btn float-left" @click="modals.mini = false" style="background:#00467f;"><i class="tim-icons icon-simple-remove" ></i></button>
            </div>
            <label for="cerca_azienda"><strong>NOME AZIENDA </strong></label>
            <input class="form-control" type="text" placeholder="Nome azienda" name="cerca_azienda" v-model="cerca_azienda" v-on:change="cercaInfo()">
            <label for="cerca_codice_fiscale"><strong>CODICE FISCALE </strong></label>
            <input class="form-control" type="text" placeholder="Codice fiscale" name="cerca_codice_fiscale" v-model="cerca_codice_fiscale" v-on:change="cercaInfo()">
            <label for="cerca_p_iva"><strong>PARTITA IVA</strong></label>
            <input class="form-control" type="text" placeholder="Partita iva" name="cerca_p_iva" v-model="cerca_p_iva" v-on:change="cercaInfo()">
            <template slot="footer">
            <!-- tabella con i risultati -->
            <div v-show="showRisultati">
                <div v-if="cerca_info.length>0">
                    <table class="table tablesorter" style="text-align: center;">
                        <thead>
                        <tr>
                            <th>AZIENDA</th>
                            <th>CF</th>
                            <th>P. IVA</th>
                            <th>SEDE</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(valori,index) in cerca_info" v-bind:key="valori.ID">
                            <td style="text-decoration:underline"><a v-on:click="compilaForm(index)">{{valori.name}}</a></td>
                            <td>{{valori.crm_cf_c}}</td>
                            <td>{{valori.crm_piva_c}}</td>
                            <td>{{valori.billing_address_street}}, {{valori.billing_address_city}} ({{valori.billing_address_state}}) {{valori.billing_address_postalcode}}</td><!--infoAzienda.billing_address_street + ", " + infoAzienda.billing_address_city + " (" + infoAzienda.billing_address_state + ") " +infoAzienda.billing_address_postalcode -->
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            </template>
        </modal>

        <!-- MODAL SICURO DI VOLER CANCELLARE NOTA-->
        <b-modal v-model="showDelete" size="md">
        <template #modal-header="{ close }">
            <b-button size="sm" style="background:#00467f;" @click="close()">X</b-button>
          </template>
        <template>
          <h3 style="color:black; text-align:center; margin-top:15px">Sicuro di voler cancellare la nota di credito?</h3>
        </template>
        <template #modal-footer="{ cancel }">
          <span style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()" v-on:click="cancelCheckData()">CHIUDI</b-button></span>
          <span style="padding-right:40px;"><b-button size="sm" style="background:#00467f;" v-on:click="confermaCancellaFunction()">CONFERMA</b-button></span>
        </template>
      </b-modal>

      <!--  MODAL CARICARE FILE -->
      <!-- <b-modal v-model="showCheckFile" size="md">
        <template #modal-header="{ close }">
            <b-button size="sm" style="background:#00467f;" @click="close()">X</b-button>
        </template>
        <template>
            <h3 style="color:black; text-align:center; margin-top:15px">Sicuro di voler caricare il documento?</h3>
            <div class="container">
              <div id="preloader_3" v-if="showLoader"></div>
            </div>
        </template>
        <template #modal-footer="{ cancel }">
            <span  v-if="!showLoader" style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()">NO</b-button></span>
            <span  v-if="!showLoader" style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="handleFileUpload()">SI</b-button></span>
        </template>
      </b-modal> -->
    </div>
</template>
<script>
import axios from 'axios';
import Card from '@/components/Cards/Card.vue';
import {Modal} from '@/components';
import NoteServices from '@/services/NoteServices';
import Services from '@/services/Services';

export default {
    components: {
      Card,
      Modal
    },
  
    data() {
        return {
            modals: {
                mini: false
            },
            //form
            cognome_nome_richiedente: null,
            ufficio: null,
            richiedente_nota: null,
            dipendenti_richiedenti: [],
            codice_fiscale: null,
            denominazione: null,
            numero_fattura: null,
            data_fattura: null,
            // addebiti_stornare: null,
            causale_nota: null,
            importo: null,
            storno_intero: true,
            metodo: null,
            // motivazione: null,
            data_ultima_emissione: null,
            if_storno: false,
            urgente: false,
            emissione: false,
            autorizzazione_emissione: null,
            emessa: null,
            sedi: [],
            nome_cognome: null,
            ufficio_referente: null,

            nota_responsabile: null,
            carica_nota: [],

            riferimento_nota: null,

            erroreCausatoDa: null,
            motivazione: null,
            azioneIntrapresa: null,

            // file: null,
            // showCheckFile: false,
            // showLoader: false,
            // fileCaricati: [],

            //pop up per cercare 
            showRisultati: false,
            nessunRisulato: false,
            cerca_azienda: '',
            cerca_codice_fiscale: '',
            cerca_p_iva: '',
            cerca_info: [],
            denominazione_search: null,
            codice_fiscale_search: null,
            partita_iva_search: null,

            idNota: null,
            showDelete: false,
            confermaCancella: false,
            access_token: null,
            token_response: [],
            user_livello: null,
            urlRichieste: 'https://sviluppoallergeni.confcom.it/'   //'https://apiintranet.confcom.it/'
        }
    },
    methods: {
        cercaInfo: async function() {
            let errore = 0;
            // const token = localStorage.getItem('access_token');
            await Services.searchInformation(this.cerca_azienda, this.cerca_codice_fiscale, this.cerca_p_iva)
            .then(response => { this.cerca_info = response.data})
            .catch( function (error) {
                // handle error
                if(error.response.status == 401){
                errore = error.response.status;
                }
            })
            if (errore == 401) {
            let value = await Services.refreshTokenFunction();
            if (value) { await this.cercaInfo(); }
            }
            this.showRisultati = true;
            if (this.cerca_info.length == 0) {
            this.nessunRisulato = true;
            }
        },

        cancellaNota: async function() {
            this.showDelete = true;
        },

        confermaCancellaFunction: async function() {
            console.log(`confermaCancellaFunction`);
            let errore = 0;
            this.confermaCancella = false;
            let response_dati = [];
            await NoteServices.deleteNota(this.idNota)
            .then(response => { response_dati = response.data})
            .catch(function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if(errore == 401){
                let value = await Services.refreshTokenFunction();
                if (value) { await this.cancellaNota(); }
            } 
            // this.showDelete = false;
            this.$router.push({
                path: '/note-credito'
            })   
        },

        //se id!=null carica nota
        caricaNota: async function() {
            let errore = 0;
            // let response_dati = [];
            await NoteServices.caricaNota(this.idNota)
            .then(response => { this.carica_nota = response.data})
            .catch(function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if(errore == 401){
                let value = await Services.refreshTokenFunction();
                if (value) { await this.caricaNota(); }
            }

            this.ufficio = this.carica_nota.ID_UFFICIO;
            this.cognome_nome_richiedente = this.carica_nota.RICHIEDENTE; 
            this.codice_fiscale = this.carica_nota.CF;
            this.denominazione = this.carica_nota.DENOMINAZIONE_DITTA;
            if (this.carica_nota.N_FATTURA != null) {
                this.numero_fattura = this.carica_nota.N_FATTURA;
            }
            this.data_fattura = this.carica_nota.DATA_FATTURA;
            this.emissione = this.carica_nota.EMISSIONE;
            this.addebiti_stornare = this.carica_nota.ADEBITI_STORNARE;
            this.causale_nota = this.carica_nota.CAUSALE_NOTA;
            this.importo = this.carica_nota.IMPORTO;
            this.metodo = this.carica_nota.METODO_IMPORTO;
            this.data_ultima_emissione = this.carica_nota.DATA_ULTIMA_EMISSIONE;
            this.if_storno = this.carica_nota.IF_STORNO;
            this.urgente = this.carica_nota.URGENTE;
            this.autorizzazione_emissione = this.carica_nota.AUTORIZ_EMISSIONE;
            this.riferimento_nota = this.carica_nota.RIFERIMENTO_NOTA;
            this.nota_responsabile = this.carica_nota.NOTA_RESPONSABILE;
            this.richiedente_nota = this.carica_nota.RICHIEDENTE_NOTA;
            this.erroreCausatoDa = this.carica_nota.ERRORE_CAUSATO_DA;
            this.motivazione = this.carica_nota.MOTIVAZIONE;
            this.azioneIntrapresa = this.carica_nota.AZIONE_INTRAPRESA;
            if (this.carica_nota.user != null) {
                //nome_cognome
                this.nome_cognome = this.carica_nota.user.NOME + ' ' + this.carica_nota.user.COGNOME
                this.ufficio_referente = this.carica_nota.user.user_site.UFFICIO
            }
            // this.emessa = ...
            console.log("carica_nota.A_ACCREDITO_META");
            console.log(this.carica_nota.A_ACCREDITO_META);
            console.log(`A_ACCREDITO_META: ID: ${this.carica_nota.A_ACCREDITO_META.ID}, value: ${this.carica_nota.A_ACCREDITO_META.VALUE}, value.name: ${this.carica_nota.A_ACCREDITO_META.VALUE.name}`)
        },

        checkData: function() {
            if (this.ufficio == null || this.codice_fiscale == null || this.denominazione == null 
                || this.numero_fattura == null  || this.data_fattura == null 
                || this.causale_nota == null || this.metodo == null 
                /* || this.data_ultima_emissione == null */ ) {
                    return false;
            } else {
                return true;
            }
        },

        compilaForm: function(index){
            let infoAzienda = this.cerca_info[index];
            this.denominazione = infoAzienda.name;
            this.codice_fiscale = infoAzienda.crm_cf_c;
        },

        getSedi: async function(){
            let errore = 0;
            await Services.getSedi()
            .then(response => { this.sedi = response.data})
            .catch(function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();;
                if (value) { await this.getSedi(); }
            }
        },

        logout: async function () {
            await Services.logout()
            .then(response => { this.results = response.data})
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.setItem('isLogged', false);
            localStorage.removeItem('user_nome');
            localStorage.removeItem('user_cognome');
            localStorage.removeItem('user_tipologia');
            localStorage.removeItem('user_email');
            localStorage.removeItem('user_livello');
            localStorage.removeItem('user_id');
            this.$router.push({
            path: '/login'
            })
            // window.location.reload()
        },
        

        salvaValori: async function() {
            let id_user = localStorage.getItem('user_id');
            let dati = []; 
            let errore = 0;
            console.log(`idnota: ${this.idNota}`);
            if (!this.checkData()) {
                alert("compilare tutti i dati");
            } else {
                if (this.idNota == null || this.idNota == '') {
                    let response_dati = [];
                    console.log(`ID_USER: ${id_user},  ID_UFFICIO: ${this.ufficio}, CF: ${this.codice_fiscale}, DENOMINAZIONE_DITTA: ${this.denominazione}, N_FATTURA: ${this.numero_fattura},  data_fattura: ${this.data_fattura},
                        CAUSALE_NOTA: ${this.causale_nota}, IMPORTO: ${this.importo},  METODO_IMPORTO: ${this.metodo}, data_ultima_emissione: ${this.data_ultima_emissione}, URGENTE: ${this.urgente}, EMISSIONE: ${this.emissione}, AUTORIZ_EMISSIONE: ${this.autorizzazione_emissione},  NOTA_RESPONSABILE: ${this.nota_responsabile}`);

                    dati.push({ 
                        ID_USER: id_user,  ID_UFFICIO: this.ufficio, RICHIEDENTE: this.cognome_nome_richiedente, 
                        // RICHIEDENTE_NOTA: this.richiedente_nota, 
                        CF: this.codice_fiscale, DENOMINAZIONE_DITTA: this.denominazione, N_FATTURA: Number(this.numero_fattura), DATA_FATTURA: this.data_fattura,
                        CAUSALE_NOTA: this.causale_nota, IMPORTO: Number(this.importo),  METODO_IMPORTO: this.metodo, DATA_ULTIMA_EMISSIONE: this.data_ultima_emissione, EMISSIONE: this.emissione, URGENTE: this.urgente, AUTORIZ_EMISSIONE: this.autorizzazione_emissione, RIFERIMENTO_NOTA: Number(this.riferimento_nota),  NOTA_RESPONSABILE: this.nota_responsabile,
                        ERRORE_CAUSATO_DA: this.erroreCausatoDa, MOTIVAZIONE: this.motivazione, AZIONE_INTRAPRESA: this.azioneIntrapresa 
                    });
                    let datiJSON = JSON.stringify(dati[0]);
                    console.log(dati);
                    console.log(datiJSON);
                    // se null crea nota
                    await NoteServices.createNota(datiJSON)
                    .then(response => { response_dati = response.data})
                    .catch(function (error) {
                        // handle error
                        if(error.response.status == 401){
                            errore = error.response.status;
                        }
                    })
                    if(errore == 401){
                        let value = await Services.refreshTokenFunction();
                        if (value) { await this.salvaValori(); }
                    }
                    this.$router.push({
                        // path: '/note-credito'
                        path: `/uploadfile-nota?id=${this.idNota}`
                    })
                } else {
                    //se non è null aggiorna
                    // "AUTORIZ_EMISSIONE":true
                    let response_dati = [];
                    dati.push({ 
                        ID_USER: id_user, ID_UFFICIO: this.ufficio, RICHIEDENTE: this.cognome_nome_richiedente, CF: this.codice_fiscale, DENOMINAZIONE_DITTA: this.denominazione, N_FATTURA: Number(this.numero_fattura), DATA_FATTURA: this.data_fattura,
                        CAUSALE_NOTA: this.causale_nota, IMPORTO: Number(this.importo),  METODO_IMPORTO: this.metodo, DATA_ULTIMA_EMISSIONE: this.data_ultima_emissione, EMISSIONE: this.emissione, 
                        URGENTE: this.urgente, AUTORIZ_EMISSIONE: this.autorizzazione_emissione, RIFERIMENTO_NOTA: Number(this.riferimento_nota),  NOTA_RESPONSABILE: this.nota_responsabile,
                        ERRORE_CAUSATO_DA: this.erroreCausatoDa, MOTIVAZIONE: this.motivazione, AZIONE_INTRAPRESA: this.azioneIntrapresa 
                    });
                    let datiJSON = JSON.stringify(dati[0]);
                    await NoteServices.updateNota(this.idNota, datiJSON)
                    .then(response => { response_dati = response.data})
                    .catch(function (error) {
                        // handle error
                        if(error.response.status == 401){
                            errore = error.response.status;
                        }
                    })
                    if(errore == 401){
                        let value =  await Services.refreshTokenFunction();
                        if (value) { await this.salvaValori(); }
                    }

                    // if (localStorage.getItem('user_livello') == 1 || localStorage.getItem('user_livello' == 2)){
                    //     this.$router.push({
                    //         // path: '/note-credito'
                    //         path: `/note-credito`
                    //     })
                    // } else {
                        this.$router.push({
                            // path: '/note-credito'
                            path: `/uploadfile-nota?id=${this.idNota}`
                        })
                    // }
                }
            }
        },

        main: async function() {
            this.user_livello = localStorage.getItem('user_livello');
            this.idNota = this.$route.query.id;
            // console.log(`idNota=${this.idNota}.`);
            this.access_token = localStorage.getItem('access_token');
            axios.defaults.withCredentials = true;
            try {
                await this.getSedi();
                if (this.idNota != null ) { //&& this.idNota != ''
                    await this.caricaNota();
                }
            } catch (error) {
                if (error.response.status == 401) {
                    await Services.refreshTokenFunction();
                }
            }   
        }
    },

    mounted() {
        
    },
    beforeMount() {
        this.main();
    }
  };
</script>
<style scoped>
/* body {
    margin: 10px; 
     padding: 10px;
} */
form {
    /* max-width: 580px; */
    margin: auto;
}
label {
    font-size: 16px;
}
.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.input-icon {
  position: relative;
}

.input-icon > i {
  position: absolute;
  display: block;
  transform: translate(0, -50%);
  top: 50%;
  pointer-events: none;
  width: 25px;
  text-align: center;
	font-style: normal;
}

.input-icon > input {
  padding-left: 25px;
  padding-right: 0;
}

.input-icon-right > i {
  right: 0;
}

.input-icon-right > input {
  padding-left: 0;
  padding-right: 25px;
  text-align: right;
}

.label-switch {
    position: relative;
  /* display: inline-block; */
  display: table-cell;
  padding-right: 10px;
  padding-left: 10px;
  font-size: 14px;
}

.switch {
  position: relative;
  /* display: inline-block; */
   display: table-cell;
  width: 55px;
  height: 34px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 0px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
input:checked + .slider {
  background-color: #00467f;
}

input:focus + .slider {
  box-shadow: 0 0 1px #00467f;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}

</style>
  